import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { features } from '~/features';
import * as AuthFeature from '~/features/auth';
import { SignIn } from '~/features/auth/pages/sign-in';
import { SignUP } from '~/features/auth/pages/sign-up';
import { selectAuthorizedState } from '~/store/user/selectors';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { useFeaturePath } from '~/utils/hooks/useFeaturePath';
import { FEATURE_ROUTER_PATH } from '../config';

export const FeatureRouter = () => {
    const getPath = useFeaturePath(FEATURE_ROUTER_PATH);

    const matchAuthPage = useRouteMatch(features[AuthFeature.name].FEATURE_ROUTER_PATH);

    const route = useAppRoute();

    const isAuthorized = useSelector(selectAuthorizedState);

    useEffect(() => {
        if (isAuthorized) {
            return;
        }

        if (matchAuthPage) {
            return;
        }

        route(getPath());
    }, [getPath, isAuthorized, matchAuthPage, route]);

    return (
        <Route path={getPath()}>
            <Switch>
                <Route path={getPath('/sign-in')} component={SignIn} />
                <Route path={getPath('/sign-up')} component={SignUP} />

                <Route path={getPath()} exact>
                    <Redirect to={getPath('/sign-in')} />
                </Route>
            </Switch>
        </Route>
    );
};
